export { default as ActivitiesModuleBrand } from './Activities'
export { default as AppCitizenModuleBrand } from './AppCitizen'
export { default as AssessmentsAndResearchModuleBrand } from './AssessmentsAndResearch'
export { default as AttendanceModuleBrand } from './Attendance'
export { default as CitizenPortalModuleBrand } from './CitizenPortal'
export { default as CitizenProfileModuleBrand } from './CitizenProfile'
export { default as DataIntegratorModuleBrand } from './DataIntegrator'
export { default as DigitalArchiveModuleBrand } from './DigitalArchive'
export { default as GeoModuleBrand } from './Geo'
export { default as InstitutionalManagementModuleBrand } from './InstitutionalManagement'
export { default as InventoryModuleBrand } from './Inventory'
export { default as MessengerModuleBrand } from './Messenger'
export { default as ObservatoryModuleBrand } from './Observatory'
export { default as ProcessesAndDocumentsModuleBrand } from './ProcessesAndDocuments'
export { default as RegulationModuleBrand } from './Regulation'
export { default as SchedulesModuleBrand } from './Schedules'
export { default as ServicesLetterModuleBrand } from './ServicesLetter'
export { default as SocialManagerModuleBrand } from './SocialManager'
export { default as UnifiedLoginModuleBrand } from './UnifiedLogin'
export { default as VulnerabilityAlertsModuleBrand } from './VulnerabilityAlerts'
